import React, { useState } from "react";

export default function MudarSenhaForm() {
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (senha !== confirmarSenha) {
      alert("As senhas não coincidem!");
      return;
    }

    console.log("Nova senha:", senha);
    alert("Senha redefinida com sucesso!");
  };

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="senha">Nova Senha</label>
        <input
          id="senha"
          type="password"
          placeholder="Digite sua nova senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="confirmarSenha">Confirmar nova senha</label>
        <input
          id="confirmarSenha"
          type="password"
          placeholder="Confirme sua nova senha"
          value={confirmarSenha}
          onChange={(e) => setConfirmarSenha(e.target.value)}
          required
        />
      </div>

      <button type="submit" className="login-button">
        Alterar Senha
      </button>
    </form>
  );
}
